import { createContext, useContext, useState, useCallback } from "react";

const DemoModalContext = createContext(null);

export const DemoModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openDemo = useCallback(() => setOpen(true), []);
  const closeDemo = useCallback(() => setOpen(false), []);
  return (
    <DemoModalContext.Provider value={{ open, openDemo, closeDemo }}>
      {children}
    </DemoModalContext.Provider>
  );
};

export const useDemoModal = () => {
  const ctx = useContext(DemoModalContext);
  if (!ctx) throw new Error("useDemoModal must be used within DemoModalProvider");
  return ctx;
};
